export const ResponseTimeType = Object.freeze({
  fast: 'fast',
  average: 'average',
  slow: 'slow',
  slowest: 'slowest',
});

export const ResponseTimeTypeLabel = Object.freeze({
  [ResponseTimeType.fast]: 'Excellent',
  [ResponseTimeType.average]: 'Average',
  [ResponseTimeType.slow]: 'Slower than average',
  [ResponseTimeType.slowest]: 'Slow',
});

export function isValid(type) {
  return Object.values(ResponseTimeType).find((elem) => elem === type);
}

export function toLabel(type) {
  return ResponseTimeTypeLabel[type];
}

export function score2Type(score) {
  if (score <= 1) {
    return ResponseTimeType.fast;
  }

  if (score <= 12) {
    return ResponseTimeType.average;
  }

  if (score <= 24) {
    return ResponseTimeType.slow;
  }

  return ResponseTimeType.slowest;
}

export function score2Label(score) {
  return toLabel(score2Type(score));
}
